module.exports = __webpack_public_path__ + "static/media/down-arow.5e3c2c8a.svg";